import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLang } from "../i18n/LangContext";
import { DIMOP_ENABLED } from "../config/flags";
import { ORG } from "../seo/site";
import { BookButton } from "./CtaPair";
//import "../styles/style.css";
import LogoWhite from "../assets/images/logo_white_transparent.png";
const Footer = () => {
  const { t } = useTranslation();
  const { lang } = useLang();
  return (
    <footer className="footer_section">
      <div className="container">
        <div className="footer_content">
          <div className="footer_contact">
            <h3>{t("footer.contact")}</h3>
            <img
              src={LogoWhite}
              alt="MALI Labs Logo"
              style={{
                height: "100px",
                width: "auto",
                objectFit: "contain",
                float: "left",
                marginRight: "15px",
                marginBottom: "10px"
              }}
            />
            <p>
              <i className="location-icon"></i>{t("footer.location")}
            </p>
            <p>
              <i className="email-icon"></i>
              <a href={`mailto:${ORG.email}`} className="footer_mail">{ORG.email}</a>
            </p>
            <p className="footer_about small" style={{ clear: "both", opacity: 0.8 }}>
              {t("footer.about")}
            </p>
          </div>

          <div className="footer_social">
            <h3>{t("footer.connect")}</h3>
            <div className="social_links">
              <a
                href="https://www.linkedin.com/company/94792684"
                className="linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <a
                href="https://github.com/MALILabs"
                className="github"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
            </div>
            <div className="footer_legal">
              <h4>{t("footer.legal")}</h4>
              <Link to="/privacy">{t("footer.privacy")}</Link>
              <Link to="/company">{t("footer.company")}</Link>
            </div>
          </div>

          <div className="footer_cta">
            <h3>{t("footer.ready")}</h3>
            <BookButton />
            {DIMOP_ENABLED && lang === "hu" && (
              <Link to="/dimop" className="footer_dimop">
                {t("footer.dimop")}
              </Link>
            )}
          </div>
        </div>

        <div className="footer_bottom">
          <p>
            &copy; {new Date().getFullYear()} MALI Labs. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
